import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function LogoSlider({ logos }) {
  const settings = {
    slidesToShow: 5,
    centerMode: true,
    centerPadding: "0px",
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0px",
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="logo-slider-wrapper">
      <h2 className="highlight-title mb-5">Our Partners</h2>
      <Slider {...settings}>
        {logos.map((src, index) => (
          <div key={index} className="logo-slide">
            <div className="logo-container">
              <img src={src} alt={`Logo ${index}`} loading="lazy" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}